/* eslint-disable react/jsx-no-useless-fragment */
import {
  Flex,
  Heading,
  Container,
  Text,
  Box,
  useColorMode,
} from "@chakra-ui/react";
import NextImage from "next/image";

import type { UserData } from "lib/components/news/News";

interface NewsHeaderProps {
  media: string;
  title: string;
  created: string;
  // updated: string;
  author: UserData;
  category: string;
}

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function NewsHeader({
  media,
  title,
  created,
  // updated,
  author,
  category,
}: NewsHeaderProps) {
  const { colorMode } = useColorMode();
  const createdDate = new Date(created);
  // const updatedDate = new Date(updated);
  const baseMediaURL = `${process.env.NEXT_PUBLIC_DIRECTUS_URL}/assets/`;

  return (
    <Flex pt={{ base: 8, md: 12 }} px={{ base: 4, md: 8 }} gap={4}>
      <Container maxW="5xl">
        <Flex direction="row" gap={4} wrap="wrap" justify="left" mx={6} pb={12}>
          <Text
            color={
              colorMode === "light" ? "text.light-muted" : "text.dark-muted"
            }
            fontSize={{ base: "xs", md: "sm" }}
            fontWeight="700"
            rounded="md"
            w="100%"
          >
            {category.toUpperCase()}
          </Text>
          <Heading
            fontWeight={700}
            fontSize={{ base: "3xl", sm: "4xl", md: "5xl" }}
            letterSpacing="-0.02em"
            textAlign="left"
            as="h1"
            w="100%"
            color={
              colorMode === "light" ? "text.light-primary" : "text.dark-primary"
            }
          >
            {title}
          </Heading>
          <Flex align="center" justify="space-between" w="100%">
            <Flex alignItems="center" justify="left" py={4}>
              <Box
                mr={{ base: 3, md: 4 }}
                w={{ base: 10, md: 12 }}
                h={{ base: 10, md: 12 }}
                position="relative"
                flexShrink={0}
                borderRadius="full"
                overflow="hidden"
              >
                <NextImage
                  src={`${baseMediaURL}${author.avatar}?width=256`}
                  alt={`${author.first_name} ${author.last_name}`}
                  fill
                  sizes="48px"
                  style={{ objectFit: "cover" }}
                />
              </Box>
              <Flex direction="column" wrap="wrap" justify="left">
                <Box
                  color={
                    colorMode === "light"
                      ? "text.light-secondary"
                      : "text.dark-secondary"
                  }
                  fontWeight="700"
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  {author.first_name} {author.last_name}
                </Box>
                <Box
                  color={
                    colorMode === "light"
                      ? "text.light-secondary"
                      : "text.dark-secondary"
                  }
                  fontWeight="400"
                  fontSize={{ base: "xs", md: "sm" }}
                >
                  {author.title}
                </Box>
              </Flex>
            </Flex>
            <Flex direction="column" wrap="wrap" justify="right">
              <Text
                color={
                  colorMode === "light" ? "text.light-muted" : "text.dark-muted"
                }
                fontWeight={400}
                fontSize={{ base: "xs", md: "sm" }}
                textAlign="right"
              >
                {MONTHS[createdDate.getMonth()]} {createdDate.getDate()},{" "}
                {createdDate.getFullYear()}
              </Text>
              {/* {updatedDate !== createdDate ? (
                <Text
                  fontWeight={350}
                  fontSize={{ base: "xs", sm: "xs", md: "sm" }}
                  textAlign="right"
                >
                  Updated: {MONTHS[updatedDate.getMonth()]}{" "}
                  {updatedDate.getDate()}, {updatedDate.getFullYear()}
                </Text>
              ) : null} */}
            </Flex>
          </Flex>
        </Flex>
        {/* Hero image — priority to ensure LCP image is preloaded */}
        <Box
          position="relative"
          w="full"
          borderRadius="2xl"
          overflow="hidden"
          shadow="lg"
          style={{ aspectRatio: "16 / 7" }}
        >
          <NextImage
            src={`${baseMediaURL}${media}?width=1000`}
            alt={title}
            fill
            priority
            sizes="(max-width: 768px) 100vw, 960px"
            style={{ objectFit: "cover" }}
          />
        </Box>
      </Container>
    </Flex>
  );
}
